export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13435.f81cd30c.jpg";